import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Button,
} from '@mui/material';
import {
  Close as CloseIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LanguageSwitcher from '../common/LanguageSwitcher';
import { ContactSupportButton } from '../common/ContactSupport';
import UserProfileSummary from './UserProfileSummary';
import AppVersionLabel from './AppVersionLabel';
import { BRAND, brandAlpha } from '../../theme/brandTokens';

const MobileMenu = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <Box
      id="mobile-menu"
      sx={{
        position: 'fixed',
        top: 0,
        right: open ? 0 : '-100%',
        width: '280px',
        height: '100vh',
        backgroundColor: BRAND.surface,
        borderLeft: `1px solid ${BRAND.line}`,
        boxShadow: `-4px 0 24px ${brandAlpha('primary', 0.12)}`,
        zIndex: 2000,
        transition: 'right 0.3s ease-in-out',
        overflowY: 'auto',
        overflowX: 'visible',
      }}
    >
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: BRAND.text }}>
            {t('settings')}
          </Typography>
          <IconButton onClick={onClose} sx={{ color: BRAND.textMuted, '&:hover': { color: BRAND.accentText } }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <UserProfileSummary user={user} sx={{ mb: 3 }} />

        <Box sx={{ mb: 2 }}>
          <Typography variant="caption" sx={{ mb: 1, fontWeight: 600, color: BRAND.textMuted, display: 'block' }}>
            {t('common.language')}
          </Typography>
          <LanguageSwitcher inMenu sx={{ mb: 0, width: '100%', minWidth: 'unset' }} />
        </Box>

        <Box sx={{ mb: 2 }}>
          <ContactSupportButton onClick={onClose} sx={{ px: 1 }} />
        </Box>

        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Button
              variant="text"
              size="small"
              startIcon={<LogoutIcon />}
              onClick={() => {
                logout();
                navigate('/management/team-member/login', { replace: true });
                onClose();
              }}
              sx={{
                justifyContent: 'flex-start',
                textTransform: 'none',
                color: '#f44336',
              }}
            >
              {t('user.logout')}
            </Button>
          </Box>
        </Box>
        <AppVersionLabel />
      </Box>
    </Box>
  );
};

export default MobileMenu;
